module.exports = __webpack_public_path__ + "img/banner.37874b56.png";